import * as types from '../types.js'

const state = {
    contactLists: [],
    selected: null,
}

const getters = {
    contactListIds: state => state.contactLists.map(list => list.id)
}

const actions = {
    [types.CONTACT_LISTS_REQUEST]: ({commit, state}) => {
        return axios.get('/api/contact-list')
        .then(resp => {
            commit(types.CONTACT_LISTS_SUCCESS, resp)
        })
        .catch(err => {
            console.log(err);
        });
    },
    [types.CONTACT_LISTS_GET_BY_PARAMS]: ({commit}, params) => {
        return axios.get('api/contact-list/by-params', {
            params: params
        }).then((resp) => {
            return resp.data
        })
    },
    [types.CONTACT_LIST_SELECT]: ({commit}, contactList) => {
        commit(types.CONTACT_LIST_SELECTED, contactList)
    }
}

const mutations = {
    [types.CONTACT_LISTS_SUCCESS]: (state, resp) => {
        state.contactLists = resp.data
    },
    [types.CONTACT_LIST_SELECTED]: (state, contactList) => {
        if(contactList.id == 0){
            state.selected = null
        }
        else{
            state.selected = contactList.id
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}